import logging from '../../../logging';
import elt from '../../../html/elt';
const log = logging('components');

/**
 * This is almost identical to DropdownInput, except it has a number value
 * rather than a string value. This keeps type checking and type coercion 
 * working in the generated component code.
 **/
export class NumericDropdownInput extends HTMLElement {

    private select: HTMLSelectElement;
    private _value: number = null;

    constructor() {
        super();
        this.select = elt('select', {class: 'form-select'});
    }

    connectedCallback() {
        const options = this.querySelectorAll('option');
        this.select.append(...options);
        this.select.value = String(this._value);
        this.select.addEventListener(
            'change', () => {
                if(this.select.value == 'null') {
                    this.value = null;
                } else {
                    this.value = Number(this.select.value);
                }
            });
        this.append(this.select);
    }

    get value(): number {
        return this._value;
    }

    set value(value: number) {
        log.debug(`NumericDropdownInput set value(${value})`);
        if(value != this._value) {
            if(this.select) {
                this.select.value = String(value);
            }
            this._value = value;
            this.dispatchEvent(new CustomEvent('change'));
        }
    }
}
export default NumericDropdownInput;
window.customElements.define('numeric-dropdown-input', NumericDropdownInput);
log.debug('Defined custom element <numeric-dropdown-input>');


